
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Angular4PaystackModule } from 'angular4-paystack';
// import { QRCodeModule } from 'angularx-qrcode';
import { DndDirective } from 'app/directives/dnd.directive';
import { AwariSearchPipe } from 'app/pipes/filter.pipe';
import { environment } from 'environments/environment';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgxPaginationModule } from 'ngx-pagination';
import { NavComponent } from './nav/nav.component';
import { CreateEventComponent } from './create-event/create-event.component';
import { EventCardComponent } from './event-card/event-card.component';
import { RouterModule } from '@angular/router';
import { MethodsComponent } from './methods/methods.component';
import { LandingPageFooterComponent } from './landing-page-footer/landing-page-footer.component';
import { GuestAccessComponent } from './guest-access/guest-access.component';
import { WebcamModule } from "ngx-webcam";
import { WalletFundingComponent } from './wallet-funding/wallet-funding.component';
import { PricingPlansComponent } from './pricing-plans/pricing-plans.component';
import { UnauthNavbarComponent } from './unauth-navbar/unauth-navbar.component';
import { TruncateWordsPipe } from 'app/directives/turncate-words.pipe';
import { OptionListComponent } from './option-list/option-list.component';
import { PublishEventComponent } from 'app/modules/events/publish-event/publish-event.component';
import { ExploreEventCardComponent } from './explore-event-card/explore-event-card.component';
import { MapComponent } from './map/map.component';
import { EventDatesDropdownComponent } from './event-dates-dropdown/event-dates-dropdown.component';
import { NgChartsModule } from "ng2-charts";
import { BannerComponent } from './banner/banner.component';
import { PackageNotificationComponent } from './package-notification/package-notification.component';
import { GooglePlacesDirective } from 'app/directives/google-places.directive';
import { MobileSidebarComponent } from './mobile-sidebar/mobile-sidebar.component';
import { PostViewerComponent } from './post-viewer/post-viewer.component';



@NgModule({
  declarations: [
    AwariSearchPipe,
    DndDirective,
    NavComponent,
    CreateEventComponent,
    EventCardComponent,
    MethodsComponent,
    LandingPageFooterComponent,
    GuestAccessComponent,
    WalletFundingComponent,
    PricingPlansComponent,
    UnauthNavbarComponent,
    TruncateWordsPipe,
    OptionListComponent,
    PublishEventComponent,
    ExploreEventCardComponent,
    MapComponent,
    EventDatesDropdownComponent,
    BannerComponent,
    PackageNotificationComponent,
    GooglePlacesDirective,
    MobileSidebarComponent,
    PostViewerComponent
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    NgxIntlTelInputModule,
    GooglePlaceModule,
    NgxPaginationModule,
    // QRCodeModule,
    CommonModule,
    NgChartsModule,
    WebcamModule,
    Angular4PaystackModule.forRoot(environment.PAYSTACK_PK),
  ],
  exports: [
    RouterModule,
    Angular4PaystackModule,
    FormsModule,
    PublishEventComponent,
    GooglePlacesDirective,
    // QRCodeModule,
    ReactiveFormsModule,
    NgxIntlTelInputModule,
    GooglePlaceModule,
    AwariSearchPipe,
    DndDirective,
    BannerComponent,
    NgxPaginationModule,
    WebcamModule,
    NavComponent,
    CreateEventComponent,
    EventCardComponent,
    LandingPageFooterComponent,
    GuestAccessComponent,
    WalletFundingComponent,
    PricingPlansComponent,
    UnauthNavbarComponent,
    TruncateWordsPipe,
    OptionListComponent,
    ExploreEventCardComponent,
    MapComponent,
    EventDatesDropdownComponent,
    PackageNotificationComponent,
    MobileSidebarComponent,
    NgChartsModule,
    PostViewerComponent,
  ],
  providers: [],
})
export class SharedModule {}